// Memory storage fallback for when sessionStorage is not available
class MemorySessionStorage {
  private storage: Map<string, string> = new Map()

  getItem(key: string): string | null {
    return this.storage.get(key) || null
  }

  setItem(key: string, value: string): void {
    this.storage.set(key, value)
  }

  removeItem(key: string): void {
    this.storage.delete(key)
  }

  clear(): void {
    this.storage.clear()
  }
}

// Test if sessionStorage is available
function isSessionStorageAvailable(): boolean {
  try {
    const testKey = '__sessionStorage_test__'
    sessionStorage.setItem(testKey, 'test')
    sessionStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

// Create storage instance with fallback
const memorySessionStorage = new MemorySessionStorage()
const sessionStorageAvailable = isSessionStorageAvailable()

export const useSessionStorageWithFallback = {
  get(key: string): string | null {
    try {
      if (sessionStorageAvailable) {
        return sessionStorage.getItem(key)
      }
      return memorySessionStorage.getItem(key)
    } catch {
      return memorySessionStorage.getItem(key)
    }
  },

  set(key: string, value: string): void {
    try {
      if (sessionStorageAvailable) {
        sessionStorage.setItem(key, value)
        return
      }
      memorySessionStorage.setItem(key, value)
    } catch {
      memorySessionStorage.setItem(key, value)
    }
  },

  remove(key: string): void {
    try {
      if (sessionStorageAvailable) {
        sessionStorage.removeItem(key)
        return
      }
      memorySessionStorage.removeItem(key)
    } catch {
      memorySessionStorage.removeItem(key)
    }
  }
}
